import React, { useState } from "react";
import car from "../../images/car copy.png";
import Rocket from "../../images/rocket.png";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const UserAds = () => {
  const [scrollValue, setScrollValue] = useState(0);
  return (
    <>
      <div className="">
        <div className=" bgSubscribeGradient text-white">
          <div
            style={{ backgroundSize: `${(2 * scrollValue) / 30}% auto` }}
            className="wantBecome container py-5 "
          >
            <div className="bg_blur px-md-4 px-3  my-3 d-flex flex-column-reverse flex-md-row text-center text-md-start justify-content-center align-items-center">
              <div>
              <div class="d-md-flex my-4 d-none flex-row flex-nowrap align-items-center justify-content-center w-100">
  <div class="me-3">
    <img src="rocket.png" alt="RocketImg" class="img-fluid" />
  </div>

  <div class="w-100">
    <h1 class="fs-2 m-0">
      Supercharge Your Car Selling Experience - Limited Time Offer!
    </h1>
    <h1 className=" d-none d-md-block w-75 fs-4 my-3">
                  Unlock Premium Benefits at Just Rs 1,000 Per Month!
                </h1>
  </div>
</div>

                
<Link to="/user-subscribe"> 
                <div className="my-4  text-center ">
               <button
                    className="custom-button2 px-md-2 px-5"
                    style={{
                      border: "none",
                      borderRadius: "15px",
                      backgroundColor: "#9c1812",
                      color: "white",
                    }}
                  >
                    More Info
                  </button>
                </div>
                </Link> 
              </div>

              <div className="d-flex flex-column  justify-content-center align-items-center">
              <img src={car} alt="CarImage" class="widthclass-custom my-0 py-0" />


                <h1 className=" d-md-none d-inline w-100  fs-4 ">
                  Unlock Premium Benefits at Just Rs 1,000 Per Month!
                </h1>
                <p
                  className="text-center fs-4 fs-md-3 my-1"
                  style={{ fontWeight: "bold" }}
                >
                  Original Price: <strike>Rs9,500</strike>
                </p>
                <p
                  className="fs-4 fs-md-3 text-center my-0"
                  style={{ fontWeight: "bold" }}
                >
                  You Pay:{" "}
                  <span style={{ color: " #fdd667" }}> Only Rs 1,000</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserAds;
